const EMAIL_ENDPOINT = "/api/forms/email";
const SFTP_UPLOAD_ENDPOINT = "/api/forms/sftp";

const writeToUsPrivate = `${EMAIL_ENDPOINT}/write-to-us-private`;
const unsubscribeBrokerNewsletter = `${EMAIL_ENDPOINT}/unsubscribe-broker-newsletter`;
const securityPackageDiByggeri = `${EMAIL_ENDPOINT}/security-package-di-byggeri`;
const orderOfferDiByggeri = `${EMAIL_ENDPOINT}/order-offer-di-byggeri`;
const offerCommercial = `${EMAIL_ENDPOINT}/offer-commercial`;
const insuranceNumber = `${EMAIL_ENDPOINT}/insurance-number`;
const insuranceCheckPrivate = `${EMAIL_ENDPOINT}/insurance-check-private`;
const hyundaiLeadsCinema = `${EMAIL_ENDPOINT}/hyundai-leads-cinema`;
const hyundaiLeads = `${EMAIL_ENDPOINT}/hyundai-leads`;
const partnerLeads = `${EMAIL_ENDPOINT}/partner-leads`;
const digitalHealthScreeningDbu = `${EMAIL_ENDPOINT}/digital-health-screening-dbu`;
const claimReportIdit = `${EMAIL_ENDPOINT}/claim-report-idit`;
const claimReportDiByggeri = `${EMAIL_ENDPOINT}/claim-report-di-byggeri`;
const caStudyInsurance = `${EMAIL_ENDPOINT}/ca-study-insurance`;
const remaHealthInsurance = `${EMAIL_ENDPOINT}/rema-sundhedsforsikring`;
const orderGreenCard = `${EMAIL_ENDPOINT}/order-green-card`;
const sparkron = `${SFTP_UPLOAD_ENDPOINT}/sparkron`;
const sparkronErhverv = `${SFTP_UPLOAD_ENDPOINT}/sparkron-erhverv`;
const betalingsservice = `${EMAIL_ENDPOINT}/betalingsservice`;

export const CALL_ME_CALLBACK_URL =
  "https://www.gjensidige.dk/api-kundeservice/open/callguide/v2/callback";
export const CALL_ME_X_CLIENT_ID = "xp-callme-module";
export const CALL_ME_X_CLIENT_VERSION = "5.5.50";

export const Endpoints = {
  WriteToUsPrivate: writeToUsPrivate,
  UnsubscribeBrokerNewsletter: unsubscribeBrokerNewsletter,
  SecurityPackageDIByggeri: securityPackageDiByggeri,
  OrderOfferDIByggeri: orderOfferDiByggeri,
  OfferCommercial: offerCommercial,
  InsuranceNumber: insuranceNumber,
  InsuranceCheckPrivate: insuranceCheckPrivate,
  HyundaiLeadsCinema: hyundaiLeadsCinema,
  HyundaiLeads: hyundaiLeads,
  DigitalHealthScreeningDBU: digitalHealthScreeningDbu,
  ClaimReportIDIT: claimReportIdit,
  ClaimReportDIByggeri: claimReportDiByggeri,
  CAStudyInsurance: caStudyInsurance,
  RemaHealthInsurance: remaHealthInsurance,
  OrderGreenCard: orderGreenCard,
  Sparkron: sparkron,
  SparkronErhverv: sparkronErhverv,
  PartnerLeads: partnerLeads,
  Betalingsservice: betalingsservice,
};

export default Endpoints;
